import {Component, Injector} from '@angular/core';
import {BlogState, Store as BlogStore} from './state/store';
import {Blog} from './state/model';
import {BlogService as BlogService} from './state/service';
import {EntityDetailComponent} from '../../components/entity-detail/component';
import {FormBuilder} from '@angular/forms';
import {BlogQuery} from './state/query';

@Component({
  templateUrl: '../../components/entity-detail/component.html',
  styleUrls: ['../../components/entity-detail/component.scss']
})
export class BlogDetailComponent extends EntityDetailComponent<Blog, BlogState, BlogStore> {

  constructor(
    public injector: Injector,
    service: BlogService,
    protected query: BlogQuery,
    protected formBuilder: FormBuilder) {
    super(injector, service, query);
  }
}
